import { render, staticRenderFns } from "./products-v2.page.vue?vue&type=template&id=d1972a62&scoped=true"
import script from "./products-v2.page.vue?vue&type=script&lang=js"
export * from "./products-v2.page.vue?vue&type=script&lang=js"
import style0 from "./products-v2.page.vue?vue&type=style&index=0&id=d1972a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1972a62",
  null
  
)

export default component.exports